import React from "react";

import { Icon } from "shared/types";

import { IconWrap } from "@components/UI/Icons/IconWrap";

const PriceTag: React.FC<Icon> = () => <div className="price-tag" />;

const IconPriceTag: React.FC<Icon> = (props) => {
  return <IconWrap IconComponent={PriceTag} type="price-tag" {...props} />;
};

export default IconPriceTag;
